import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import { isLoggedIn } from './IsLoggedIn';
import { Navigate } from 'react-router-dom';
import { getAuthUser } from 'utils/auth';

// Logged-in user ko kahan bhejna hai (driver ke liye My Trips, baqi ke liye dashboard)
const homePath = () => (getAuthUser().role === 'driver' ? '/flour-mill/transport/trips' : '/dashboard/default');

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: isLoggedIn() ? <Navigate to={homePath()} /> : <LoginPage />
        },
        {
          path: '/register',
          element: isLoggedIn() ? <Navigate to="/dashboard/default" /> : <RegisterPage />
        }
      ]
    }
  ]
};

export default LoginRoutes;
